export default "__VITE_PUBLIC_ASSET__4a208411__"